import { Box, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';

import {
  BOTTOM_NAV_HEIGHT,
  shouldShowBuyerBottomNav,
} from '../layouts/bottom-nav/bottom-nav-config';

const OFFLINE_MESSAGE = 'Anda sedang offline';
const PRODUCT_DETAIL_MOBILE_ACTION_HEIGHT = 96;

function getMobileBottom(pathname: string) {
  if (shouldShowBuyerBottomNav(pathname)) {
    return `${BOTTOM_NAV_HEIGHT}px`;
  }

  if (pathname.startsWith('/product/')) {
    return `${PRODUCT_DETAIL_MOBILE_ACTION_HEIGHT}px`;
  }

  return '0';
}

export function OfflineBanner() {
  const router = useRouter();
  const mobileBottom = getMobileBottom(router.pathname);

  return (
    <Box
      role="status"
      aria-label={OFFLINE_MESSAGE}
      aria-live="polite"
      position="fixed"
      right="0"
      bottom={{ base: mobileBottom, md: '0' }}
      left="0"
      zIndex="banner"
      bg="gray.800"
      color="white"
      px="4"
      py="2"
      textAlign="center"
    >
      <Text fontSize="sm" fontWeight="semibold">
        {OFFLINE_MESSAGE}
      </Text>
    </Box>
  );
}
